import jsrsasign from "jsrsasign";

/**
 * 随机字符串
 * @param {} length 
 */
function randomStr(length) {
    let str = '';
    let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (let i = 0; i < length; i++) {
        str += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    str += Date.now().toString(36);
    return str.slice(0, length);
}

/**
 * 签名生成
 * @param {} timestamp 
 * @param {*} nonce 
 * @param {*} options 
 */
function CreateSign(content, prikey) {

    const sig = new jsrsasign.KJUR.crypto.Signature({ "alg": "SHA256withRSA" });
    const rsa = jsrsasign.KEYUTIL.getKey(prikey)
    sig.init(rsa)

    sig.updateString(content);
    var sign = jsrsasign.hextob64(sig.sign())
    return sign;
}

export default {
    randomStr,
    CreateSign
}  